import { categories } from '@/mocks/categories';

export default function CategoryButtons() {
  const iconMap: Record<string, string> = {
    'Shoes': 'ri-footprint-line',
    'Hoodies / Sweaters': 'ri-t-shirt-line',
    'T-Shirts': 'ri-t-shirt-line',
    'Jackets': 'ri-shirt-line',
    'Pants / Shorts': 'ri-user-line',
    'Headwear': 'ri-user-5-line',
    'Sets': 'ri-stack-line',
    'Underwear / Underpants': 'ri-checkbox-blank-line',
    'Jersey': 'ri-t-shirt-line',
    'Accessories': 'ri-brush-line',
    'Bags': 'ri-handbag-line',
    'Belts': 'ri-link',
    'Perfumes': 'ri-drop-line',
    'Other Stuff': 'ri-more-line',
  };

  return (
    <section id="categories" className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide uppercase mb-4">
            Shop by Category
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            Browse <span className="italic text-accent-600">Basetao</span> Product Categories
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-base leading-relaxed">
            Explore organized product spreads across every category. Each link takes you directly to curated collections on our main platform.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-2.5 p-4 rounded-xl bg-background-100 border border-background-200/60 hover:border-accent-300/40 hover:bg-accent-50/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${iconMap[cat.name] || 'ri-folder-line'} text-base`}></i>
              </div>
              <span className="text-xs font-medium text-foreground-700 text-center leading-tight group-hover:text-accent-700 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}